var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSlideBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "arrow-left-square-fill",
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_24393",
    "data-name": "Group 24393"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_105875",
    "data-name": "Path 105875",
    d: "M42,36.75A5.25,5.25,0,0,1,36.75,42H5.25A5.25,5.25,0,0,1,0,36.75V5.25A5.25,5.25,0,0,1,5.25,0h31.5A5.25,5.25,0,0,1,42,5.25ZM30.188,19.688H14.981l5.636-5.633A1.314,1.314,0,0,0,18.758,12.2l-7.875,7.875a1.312,1.312,0,0,0,0,1.858L18.758,29.8a1.314,1.314,0,0,0,1.858-1.858l-5.636-5.633H30.188a1.313,1.313,0,0,0,0-2.625Z",
    fill: "#5a32c7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSlideBack);
export default __webpack_public_path__ + "static/media/slide-back.11d8025bf7f3f6dbdde11dc1b0e25771.svg";
export { ForwardRef as ReactComponent };